import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAllDocumentDiscounts } from '../../../../../../lib/api/documentDiscount';
import CustomAlert from '../../../../../../lib/designSystem/Alert';
import CenteredCircularProgress from '../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from '../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../lib/designSystem/Table';
import { hasAnyPermissions } from '../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../services/redux/authSlice';
import DiscountDetails from './components/DiscountDetails';

const headers: { key: string; label: string; type?: any }[] = [
  { key: 'id', label: 'ID', type: 'numeric-id' },
  { key: 'folio', label: 'Folio documento' },
  { key: 'businessName', label: 'Cliente' },
  { key: 'documentAmount', label: 'Monto documento', type: 'money' },
  { key: 'amount', label: 'Monto condonado', type: 'money' },
  { key: 'executedAt', label: 'Ejecutado el', type: 'date' },
];

const Discounts: React.FC = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const [failure, setFailure] = useState('');
  const [discounts, setDiscounts] = useState<any>([]);
  const [openNewDiscount, setOpenNewDiscount] = useState(false);
  const [edit, setEdit] = useState(false);
  const newDiscount = {
    documentId: '',
    amount: 0,
  };
  const [discount, setDiscount] = useState(newDiscount);
  const fetchDocumentDiscounts = async () => {
    setLoading(true);
    try {
      const response = await getAllDocumentDiscounts(dispatch);
      setDiscounts(response);
    } catch (error) {
      alert('Error al cargar los pagos');
    }
    setLoading(false);
  };

  const handleNewDiscount = () => {
    setEdit(false);
    setDiscount(newDiscount);
    setOpenNewDiscount(true);
  };

  // const handleDetails = async (id: string) => {
  //   const discountSearched = discounts.find(
  //     (discount: any) => discount.id === id,
  //   );
  //   if (!discountSearched) return;
  //   setDiscount(discountSearched);
  //   setOpenNewDiscount(true);
  //   setEdit(true);
  // };

  // const actions: any = [
  //   {
  //     actionLabel: 'Ver',
  //     action: handleDetails,
  //   },
  // ];

  const buttonsData: CustomButtonProps[] = [
    {
      action: () => handleNewDiscount(),
      name: 'Nueva condonación',
      color: 'primary',
      disabled: !hasAnyPermissions(user, ['financing_discount_new']),
    },
  ];

  useEffect(() => {
    fetchDocumentDiscounts();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <div>
      <HeaderWithActions
        title="Acá encontrarás todos las condonaciones que hayas realizado."
        variant="body1"
        buttons={buttonsData}
      />
      <EnhancedTable
        dataHeaders={headers}
        data={discounts}
        rowsPerPageDefault={50}
        exportToFile="xlsx"
        lastElement
        // actions={actions}
        // showActions
      />
      {openNewDiscount && (
        <DiscountDetails
          discount={discount}
          setDiscount={setDiscount}
          open={openNewDiscount}
          setOpen={setOpenNewDiscount}
          setSuccess={setSuccess}
          setFailure={setFailure}
          setUp={fetchDocumentDiscounts}
          edit={edit}
        />
      )}

      <CustomAlert
        open={success.length}
        title={success}
        onClose={() => {
          setSuccess('');
        }}
        setOpen={setSuccess}
        severity="success"
        size="small"
        variant="outlined"
      />
      <CustomAlert
        open={failure.length}
        title={failure}
        onClose={() => {
          setFailure('');
        }}
        setOpen={setFailure}
        severity="error"
        size="small"
        variant="outlined"
      />
    </div>
  );
};

export default Discounts;
